import { render, staticRenderFns } from "./SucursalTitulo.vue?vue&type=template&id=75f15172"
import script from "./SucursalTitulo.vue?vue&type=script&lang=js"
export * from "./SucursalTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports